import { z } from 'zod';

// ── Cut List ──

export const CutListPartSchema = z.object({
  label: z.string(),
  width: z.number(),
  height: z.number(),
  areaName: z.string(),
  sourceItemId: z.string(),
  qty: z.number(),
});

export const CutListEntrySchema = z.object({
  materialId: z.string(),
  materialName: z.string(),
  materialType: z.enum(['sheet', 'order', 'skipped']),
  sheetSize: z.string().nullable(),
  sheetsNeeded: z.number().nullable(),
  costPerSheet: z.number().nullable(),
  totalCost: z.number(),
  efficiency: z.number().nullable(),
  unit: z.string(),
  totalQty: z.number(),
  parts: z.array(CutListPartSchema),
});

export type CutListPart = z.infer<typeof CutListPartSchema>;
export type CutListEntry = z.infer<typeof CutListEntrySchema>;

// ── Nesting Summary ──

export const NestingSummarySchema = z.object({
  totalSheets: z.number(),
  totalCost: z.number(),
  averageEfficiency: z.number(),
  materialCount: z.number(),
  skippedCount: z.number(),
});

export type NestingSummary = z.infer<typeof NestingSummarySchema>;
